import Input from './Input';
import InputMask from './InputMask';
import InputPassword from './InputPassword';
import InputStyle from './InputStyle';

Input.Mask = InputMask;
Input.Password = InputPassword;

export { Input, InputStyle };
